import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-store-email-config',
  standalone: false,
  templateUrl: './store-email-config.component.html',
  styleUrls: ['./store-email-config.component.scss']
})
export class StoreEmailConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'store-email',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'storeid', header: 'Store', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup', isPrimary: true, isReadonlyOnEdit: true },
        { field: 'email', header: 'Email', type: ColumnType.String, isPrimary: true, isReadonlyOnEdit: true },
        {
          field: 'folderlocationid',
          header: 'Folder Location',
          type: ColumnType.MultiSelectComplex,
          setUrl: 'folderlocation/lookup',
          isSingleSelect: true
        },
        { field: 'isenabled', header: 'Enabled', type: ColumnType.Boolean },
        { field: 'enableemailinstruction', header: 'Enable Email Instruction', type: ColumnType.Boolean, isHidden: true, notInForm: true }
      ],
      addFormConfig: {
        header: 'Add Store Email'
      },
      isConfigurable: true,
      canEdit: true
    };

  }
}
